import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DeleteConfirmationModalComponent } from '../modals';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-prof-cert-table-component',
    templateUrl: './prof-cert-component.html',
    styleUrls: ['./prof-cert-component.scss']
})

export class ProfCertTableComponent implements OnInit {
    @Input() data_array : Array<any>;
    @Output() delete = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();

    constructor(private modalService: NgbModal) {
    	
    }

    ngOnInit() {}

    deleteAction(data){
        const modalRef = this.modalService.open(DeleteConfirmationModalComponent);
              const p1 = data.certification   ? data.certification.professional_cert_name_en : data.professional_certificate_name
              const p2 = data.specialization
              modalRef.componentInstance.Title = " "+p1+"/"+p2;
              modalRef.result.then((result) => {
                    if(result.status)
                        this.delete.emit(data.id);
                  }).catch((error) => {
              });
    }

    editAction(data){
        this.edit.emit({... data});
    }
}
